import { render } from "./ProjectsGrid.vue?vue&type=template&id=3bfbb21a"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__